<template>
  <PModal :title="title" v-model="show">
    <template #activator="{ open }">
      <PButton
        data-sentry-id="ExportLoaderOpenButton"
        :disabled="disabled"
        @click="onClick($event, open)"
        mode="tertiary"
        class="ml-auto mr-1 sm:ml-1 border-grey-625"
      >
        Exporter
      </PButton>
    </template>

    <div v-if="!link" class="flex items-center gap-2">
      <span>Export en cours...</span>
      <PSpinner size="lg" enabled />
    </div>
    <div v-else>
      <PLink :to="link" @click="show = false" data-sentry-id="ExportLoaderDownloadButton">Télécharger l'export</PLink>
    </div>
  </PModal>
</template>

<script setup lang="ts">
import { PModal, PSpinner, PLink, useAlertManager, AlertType, AlertDuration, PButton } from "@pasta/box-v2";
import { computed, ref, watch } from "vue";
import { type LetterFileSearchDto } from "../dto/letter-file.dto";
import { useExportStore } from "../stores/export.store";
import { useSimpleFeatureStore } from "../stores/simple-features.store";

interface Props {
  searchBody: LetterFileSearchDto;
  disabled?: boolean;
}
const props = defineProps<Props>();
const emit = defineEmits<{ (e: "click", value: Event): void }>();

const title = computed(() => (link.value ? "Fichier prêt" : "Veuillez patienter"));

const exportStore = useExportStore();
const simpleFeatureStore = useSimpleFeatureStore();

const show = ref<boolean>(false);
const link = ref<string>("");
watch(
  () => show.value,
  async () => {
    if (show.value) {
      const { id } = await exportStore.startExport(props.searchBody);
      const ready = await exportStore.poll(id);
      if (ready) {
        if (simpleFeatureStore.tmpDisableLinksRefacto || simpleFeatureStore.linkShortenerEnabled) {
          link.value = await exportStore.getLink(id);
        } else {
          link.value = `${await exportStore.getLink(id)}&asAttachment=true`;
        }
      } else {
        useAlertManager().createAlert({
          message: "L'export a échoué",
          type: AlertType.ERROR,
          duration: AlertDuration.INFINITE,
        });
      }
    } else {
      link.value = "";
    }
  }
);

function onClick(e: Event, open: () => void) {
  open();
  emit("click", e);
}
</script>
